/**
 * CRM Contract Create New - Crear contrato para agentes (new)
 * Ruta: /crm/contratos-new/crear
 * Reutiliza AdminContractCreate con contractsListPath para navegación correcta
 */
import { AdminContractCreate } from '@/pages/admin/AdminContractCreate';

export function CRMContractCreateNew() {
  return <AdminContractCreate contractsListPath="/crm/contratos-new" />;
}
